module.exports = __webpack_public_path__ + "img/Biblia_Bucuresti_1688.dbbd5330.png";